// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class EmployeeResource extends Resource {
    basePath: string = 'entities/employees/';

    objectPath: string = 'entities/employees/{ident}/';
}
